/* global fbq */
/* eslint no-undef: "error" */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route, applyRouterMiddleware, browserHistory } from 'react-router';
import { useScroll } from 'react-router-scroll';
import { syncHistoryWithStore } from 'react-router-redux';
import { initialiseDao } from 'ml-fetch';
import Analytics from './shared/google-analytics/Analytics';

// Set up Dao module
const deviceType = 'web';
const deviceId = 'web';
let baseUrl = 'https://api-dot-mylife-bio.appspot.com';
if (process.env.NODE_ENV === 'development') {
    baseUrl = 'http://10.110.30.75:8181';
}
initialiseDao(baseUrl, deviceType, deviceId, Analytics);

// Set up Google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-84092228-1');

// Sync history with redux
import configureStore from './store/configureStore';
const history = syncHistoryWithStore(browserHistory, configureStore());
history.listen((location) => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
    fbq('track', 'PageView');
});

// Set up components
import { initialiseComponents } from 'ml-component-web';
import LoadingIndicator from './component/LoadingIndicator';
initialiseComponents(retry => (
    <div className="loading">
        <div>There was a problem connecting to our servers</div>
        <button className="mdl-button mdl-js-button mdl-button--primary" onClick={retry}>Try again</button>
    </div>
), loadingOptions => (
    <LoadingIndicator loadingOptions={loadingOptions} />
));

// Make sure external CSS is loaded first so app CSS overrides it
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './index.css';
import './bootstrap.css';

import MyBabyBioHandler from './handler/MyBabyBioHandler';
import HomeHandler from './handler/HomeHandler';
import InvitationHandler from './handler/InvitationHandler';
import PageHandler from './handler/PageHandler';
import AboutHandler from './handler/AboutHandler';
import EntryHandler from './handler/EntryHandler';
import PressHandler from './handler/PressHandler';
import FAQHandler from './handler/FAQHandler';
import AcceptableUsePolicyHandler from './handler/policy/AcceptableUsePolicyHandler';
import AppEULAHandler from './handler/policy/AppEULAHandler';
import AppPrivacyPolicyHandler from './handler/policy/AppPrivacyPolicyHandler'
import CookiePolicyHandler from './handler/policy/CookiePolicyHandler';
import PrivacyPolicyHandler from './handler/policy/PrivacyPolicyHandler';
import TermsOfUseHandler from './handler/policy/TermsOfUseHandler';
import ZellieHandler from './handler/ZellieHandler';

ReactDOM.render(
    <Provider store={configureStore()}>
        <Router history={history} render={applyRouterMiddleware(useScroll())}>
            <Route component={MyBabyBioHandler}>
                <Route component={PageHandler}>
                    <Route component={HomeHandler} path="/" />
                    <Route component={AboutHandler} path="/about" />
                    <Route component={PressHandler} path="/press" />
                    <Route component={FAQHandler} path="/faq" />
                </Route>
                <Route component={EntryHandler} path="/entry" />
                <Route component={EntryHandler} path="/invitationReminder" />
                <Route component={InvitationHandler} path="/invite" />

                <Route path="/acceptableUsePolicy" component={AcceptableUsePolicyHandler} />
                <Route path="/appEULA" component={AppEULAHandler} />
                <Route path="/appPrivacyPolicy" component={AppPrivacyPolicyHandler} />
                <Route path="/cookiePolicy" component={CookiePolicyHandler} />
                <Route path="/privacyPolicy" component={PrivacyPolicyHandler} />
                <Route path="/termsOfUse" component={TermsOfUseHandler} />

                <Route component={ZellieHandler} path="/zellie" />
            </Route>
        </Router>
    </Provider>,
    document.getElementById('root'),
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/